module.exports = __webpack_public_path__ + "img/Muhammad-Rommy-Aniswar.c0ed4366.png";